// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_f417234f","iconWrapper":"_dd11b3a4","icon":"_21039ef7"};